<template>
    <b-badge class="badge-keyword md f-400" :variant="status.variant" :title="tr(status.title)">
        <i v-if="status.glyph" class="fas" :class="status.glyph"/>
        <slot>
            <span class="mr-1">{{keyword.label || keyword.keyword}}</span>
            <span class="keyword-value f-500">
                <span v-if="keyword.count != null">{{keyword.count}}/{{ keyword.min}}-{{keyword.max}}</span>
                <span  v-else>({{ keyword.min}}-{{keyword.max}})</span>
            </span>
<!--            {{distance}}-->
        </slot>

        <slot name="actions"></slot>

<!--        {{keyword.variations}}-->
    </b-badge>
</template>

<script>
export default {
    name: `badge-keyword`,
    props: {
        keyword: {type: Object, required: true}
    },
    computed: {
        distance() {
            if (this.keyword.count === 0)
                return 1;

            if (this.keyword.count < this.keyword.min) {
                return (this.keyword.min - this.keyword.count) / this.keyword.min;
            } else if (this.keyword.count > this.keyword.max) {
                return (this.keyword.count - this.keyword.max) / this.keyword.max;
            } else {
                return 0;
            }
        },
        status() {
            if (isNullOrUndefined(this.keyword.count)) {
                return {
                    variant: `light`
                };
            }
            if (this.distance === 0) {
                return {
                    variant: `light-success`,
                    glyph: `fa-circle-check`,
                    title: `Within Recommended Range|Correspond aux valeurs recommandées`
                };
            } else {
                const variant = Math.abs(this.distance) > 0.5 ? `light-danger` : `light-warning`;
                let glyph = `fa-chevron-down`;
                let title = `Above Recommended Range|Au dessus des valeurs recommendées`;
                if (this.keyword.count < this.keyword.min) {
                    glyph = `fa-chevron-up`;
                    title = `Below Recommended Range|En dessous des valeurs recommendées`;
                }

                return {
                    variant,
                    glyph,
                    title
                };
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.badge-keyword {
    font-size: .91rem !important;
    letter-spacing: -0.3px;

    .fas {
        font-size: 10px;
        margin-left: -4px;
        margin-right: 2px;
    }
}
</style>
